app.service('dataTablesUtils', ['$filter', 'CONSTANTS', function ($filter, CONSTANTS) {
  var dataTablesUtils = this;

  dataTablesUtils.getColIndex = function (table_id, data_name) {
    var t = $('#' + table_id).DataTable();

    function match_column(o) {
      return o.data === data_name;
    }

    return t.settings().init().columns.findIndex(match_column);
  };

  dataTablesUtils.applyColFilter = function (table_id, data_name, filter_expression) {
    var col_index = dataTablesUtils.getColIndex(table_id, data_name);
    $('#' + table_id).DataTable().columns(col_index).search(filter_expression, true, false).draw();
  };

  dataTablesUtils.is_export_column = function (table, idx) {
    var is_visible = (table.column(idx).visible());
    if (is_visible) {
      if (table.column(idx).header().className.indexOf('skipCol') !== -1) {
        return false;
      }
    }
    return is_visible;
  };

  dataTablesUtils.get_export_columns = function (table, columns) {
    if (!angular.isDefined(table)) {
      alert('report_columns is not defined');
      return;
    }

    var export_columns = $.grep(columns, function (v, i) {
      return dataTablesUtils.is_export_column(table, i);
    });
    return export_columns;
  };

  var getPageSizeForPDF = function (numberOfColumns) {
    var pageSizes = [
      { from: 0,  to: 12, size: 'A4' },
      { from: 12, to: 20, size: 'A3' },
      { from: 20, to: 28, size: 'A2' },
      { from: 28, to: 38, size: 'A1' },
      { from: 38, to: 50, size: 'A0' },
      { from: 50, to: 62, size: '2A0' },
      { from: 62, to: 74, size: '4A0' }
    ];

    var pageSize = _.find(pageSizes, function (size) {
      return (numberOfColumns >= size.from && numberOfColumns < size.to);
    });

    if (pageSize !== undefined) {
      return pageSize.size;
    }

    return 'A4';
  };

  dataTablesUtils.get_pdf_button = function (report_name, user, scope, dropdown, custom_headers, report_table_key, report_columns_key) {
    var btn_pdf = {
      extend: 'pdfHtml5',
      title: report_name,
      exportOptions: {
        orthogonal: 'export',
        columns: function (idx, data, node) {
          return dataTablesUtils.is_export_column(scope[report_table_key], idx);
        },
        format: {
          footer: function ( data, row, column, node ) {
            return data.replace( /<br\s*[/]?>/gi, ' / ');
          }
        }
      },
      orientation: 'landscape',
      text: 'Export PDF',
      footer: true,
      className: (dropdown) ? 'mat ui export-pdf-dropdown primary button' : 'mat ui export-pdf-button small primary button',
      customize: function (doc) {
        doc.styles.tableHeader.fontSize = 10;
        doc.defaultStyle.fontSize = 9;
        doc.styles.title.alignment = 'center';
        doc.pageMargins = [40, 60, 40, 40];
        var content_index = 1;

        doc.content.splice(1, 0, {
          margin: [0, 0, 0, 12],
          alignment: 'left',
          text: 'Date: ' + $filter('date')(
            new Date(),
            CONSTANTS.dateTimeFormat.MEDIUM_24H_TIME_NO_SEC)
        });
        content_index += 1;

        if (custom_headers && (typeof custom_headers === 'string')) {
          doc.content.splice(content_index, 0, {
            margin: [0, 0, 0, 12],
            alignment: 'left',
            text: custom_headers
          });
          content_index += 1;
        } else if (custom_headers && custom_headers.length) {
          for (var i = 0; i < custom_headers.length; i++) {
            doc.content.splice(content_index, 0, {
              margin: [0, 0, 0, 12],
              alignment: 'left',
              text: custom_headers[i]
            });
            content_index += 1;
          }
        }

        if (user) {
          doc.content.splice(1, 0, {
            alignment: 'left',
            text: 'User: ' + user.first_name + ' ' + user.last_name
          });
          content_index += 1;
        }

        var visible_columns = dataTablesUtils.get_export_columns(scope[report_table_key],
          scope[report_columns_key]);
        doc['pageSize'] = getPageSizeForPDF(visible_columns.length);

        var rowCount = doc.content[content_index].table.body.length;

        for (i = 1; i < rowCount; i++) {
          for (var col_index = 0; col_index < visible_columns.length; col_index++) {
            if (visible_columns[col_index].type == 'num') {
              doc.content[content_index].table.body[i][col_index].alignment = 'right';
            }
          }
        }

        for (col_index = 0; col_index < visible_columns.length; col_index++) {
          var alignment = visible_columns[col_index].type == 'num' ? 'right' : 'left';
          if (doc.content[content_index].table.body[0][col_index] != null) {
            doc.content[content_index].table.body[0][col_index].alignment = alignment;
          }
        }

        doc['header'] = (function (page, pages) {
          return {
            columns: [
              {
                alignment: 'left',
                margin: [40, 20, 0, 0],
                image: 'data:image/png;base64,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',
                height: 30,
                width: 93
              }
            ]
          };
        });

        doc['footer'] = (function (page, pages) {
          return {
            columns: [
              {
                alignment: 'center',
                text: [
                  { text: page.toString() },
                  ' of ',
                  { text: pages.toString() }
                ]
              }
            ],
            margin: [0, 10, 0, 0]
          };
        });
      }
    };

    return btn_pdf;
  };

  dataTablesUtils.get_csv_button = function (report_name, user, scope, dropdown, custom_headers, report_table_key, report_columns_key) {
    var btn_csv = {
      extend: 'csvHtml5',
      text: 'Export CSV',
      className: (dropdown) ? 'mat ui export-csv-dropdown primary button' : 'mat ui export-csv-button small primary button',
      title: report_name,
      footer: true,
      exportOptions: {
        format: {
          footer: function ( data, row, column, node ) {
            return data.replace( /<br\s*[/]?>/gi, ' / ');
          }
        },
        orthogonal: 'export',
        columns: function (idx, data, node) {
          return dataTablesUtils.is_export_column(scope[report_table_key], idx);
        }
      },
      customize: function (csv, config) {
        var visible_columns = dataTablesUtils.get_export_columns(scope[report_table_key],
          scope[report_columns_key]).length;

        function GetRow(csv, column_count, row_text) {
          return ['"' + row_text + '"'].concat(Array(column_count - 1)).join(',') + '\n';
        }

        function wrapValue(value) {
          if (value.trim() !== '' && value.startsWith('"0')) {
            return value.replace(/^"(.*)"$/, '\t$1');
          }
          return value;
        }

        var r1 = GetRow(csv, visible_columns, report_name);
        var r2 = (user)
          ? GetRow(csv, visible_columns, 'User: ' + user.first_name + ' ' + user.last_name)
          : '';

        var r3 = GetRow(csv,
          visible_columns,
          'Date: ' + $filter('date')(new Date(), CONSTANTS.dateTimeFormat.MEDIUM_24H_TIME_NO_SEC));

        var r0 = GetRow(csv, visible_columns, '');
        var r_custom_headers = '';

        if (custom_headers && (typeof custom_headers === 'string')) {
          r_custom_headers = GetRow(csv, visible_columns, custom_headers);
        } else if (custom_headers && custom_headers.length) {
          for (let i = 0; i < custom_headers.length; i++) {
            r_custom_headers += GetRow(csv, visible_columns, custom_headers[i]);
          }
        }

        var rows = csv.split('\n');
        var csvContent = rows[0].trim() + '\n';
        for (let i = 1; i < rows.length; i++) {
          let row = rows[i].trim();
          if (row) {
            let values = row.split(',');
            csvContent += values.map(wrapValue).join(',') + '\n';
          }
        }
        return r1 + r0 + r2 + r3 + r_custom_headers + r0 + csvContent;
      }
    };

    return btn_csv;
  };

  dataTablesUtils.excelInsertRow = function (sheet, insert_row_index, row_text) {
    var key = 'A';
    var clRow = $('row', sheet);

    clRow.each(function () {
      var attr = $(this).attr('r');
      var ind = parseInt(attr);

      if (ind < insert_row_index) {
        return;
      }

      ind = ind + 1;
      $(this).attr('r', ind);
    });

    $('row c ', sheet).each(function () {
      var attr = $(this).attr('r');
      var pre = attr.substring(0, 1);
      var ind = parseInt(attr.substring(1, attr.length));

      if (ind < insert_row_index) {
        return;
      }

      ind = ind + 1;
      $(this).attr('r', pre + ind);
    });

    var new_row = ['<row r="' + insert_row_index + '">',
      '<c t="inlineStr" r="' + key + insert_row_index + '" s="0">',
      '<is>',
      '<t>' + row_text + '</t>',
      '</is>',
      '</c>',
      '</row>'].join('\n');

    sheet.childNodes[0].childNodes[1].innerHTML = new_row + sheet.childNodes[0].childNodes[1].innerHTML;
  };

  dataTablesUtils.get_excel_button = function (report_name, user, scope, dropdown, custom_headers, report_table_key, report_columns_key, custom_styles) {
    var btn_excel = {
      extend: 'excelHtml5',
      autoFilter: true,
      createEmptyCells: true,
      title: '',
      text: 'Export Excel',
      className: (dropdown) ? 'mat ui export-excel-dropdown primary button' : 'mat ui export-excel-button small primary button',
      filename: report_name,
      footer: true,
      exportOptions: {
        format: {
          footer: function ( data, row, column, node ) {
            return data.replace( /<br\s*[/]?>/gi, ' / ');
          }
        },
        columns: function (idx, data, node) {
          return dataTablesUtils.is_export_column(scope[report_table_key], idx);
        },
        orthogonal: 'export',
        stripNewlines: false
      },
      customize: function (xlsx, button_config, table_api) {
        var sheet = xlsx.xl.worksheets['sheet1.xml'];

        var styles = xlsx.xl['styles.xml'];
        var lastXfIndex = $('cellXfs xf', styles).length - 1;

        var customNumFmt = '<numFmt numFmtId="170" formatCode="[$-409]d mmm yyyy;@"/>';
        styles.childNodes[0].childNodes[0].innerHTML += customNumFmt;

        customNumFmt = '<numFmt numFmtId="175" formatCode="dd mmm yyyy h:mm &quot;GMT&quot;;@"/>';
        styles.childNodes[0].childNodes[0].innerHTML += customNumFmt;

        var generalRightAlignedStyleId = lastXfIndex + 1;
        var customStyle = '<xf numFmtId="0" fontId="0" applyFont="1" borderId="1" applyBorder="1" applyFill="0" xfId="0" applyAlignment="1">' +
            '<alignment horizontal="right" vertical="top"/></xf>';
        styles.childNodes[0].childNodes[5].innerHTML += customStyle;

        var headerRightAlignedStyleId = lastXfIndex + 2;
        customStyle = '<xf numFmtId="0" fontId="2" applyFont="1" borderId="1" applyBorder="1" fillId="2" applyFill="1" xfId="0" applyAlignment="1">' +
            '<alignment horizontal="right"/></xf>';
        styles.childNodes[0].childNodes[5].innerHTML += customStyle;

        var generalLeftAlignedStyleId = lastXfIndex + 3;
        customStyle = '<xf numFmtId="0" borderId="1" applyBorder="1" xfId="0" applyAlignment="1">' +
            '<alignment vertical="top"/></xf>';
        styles.childNodes[0].childNodes[5].innerHTML += customStyle;

        var headerLeftAlignedStyleId = lastXfIndex + 4;
        customStyle = '<xf numFmtId="0" fontId="2" applyFont="1" borderId="1" applyBorder="1" fillId="2" applyFill="1" xfId="0" applyAlignment="1">' +
            '<alignment horizontal="left"/></xf>';
        styles.childNodes[0].childNodes[5].innerHTML += customStyle;

        var dateRightAlignedStyleId = lastXfIndex + 5;
        customStyle = '<xf numFmtId="170" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyFont="1" applyBorder="1" applyAlignment="1">' +
            '<alignment horizontal="right" vertical="top"/></xf>';
        styles.childNodes[0].childNodes[5].innerHTML += customStyle;

        var dateTimeRightAlignedStyleId = lastXfIndex + 6;
        customStyle = '<xf numFmtId="175" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyFont="1" applyBorder="1" applyAlignment="1">' +
            '<alignment horizontal="right" vertical="top"/></xf>';
        styles.childNodes[0].childNodes[5].innerHTML += customStyle;

        if (custom_styles && custom_styles.appendStyleDefinations) {
          custom_styles.appendStyleDefinations(styles);
        }

        var defaultRowHeight = 11;

        var visible_columns = dataTablesUtils.get_export_columns(scope[report_table_key],
          scope[report_columns_key]);
        var headerRows = 0;

        if (custom_headers && (typeof custom_headers === 'string')) {
          dataTablesUtils.excelInsertRow(sheet, 1, custom_headers);
          headerRows += 1;
        } else if (custom_headers && custom_headers.length) {
          for (var i = custom_headers.length - 1; i >= 0; i--) {
            dataTablesUtils.excelInsertRow(sheet, 1, custom_headers[i]);
            headerRows += 1;
          }
        }

        dataTablesUtils.excelInsertRow(sheet,
          1,
          'Date: ' + $filter('date')(new Date(), CONSTANTS.dateTimeFormat.MEDIUM_24H_TIME_NO_SEC));
        headerRows += 1;

        if (user) {
          dataTablesUtils.excelInsertRow(sheet, 1, 'User: ' + user.first_name + ' ' + user.last_name);
          headerRows += 1;
        }
        dataTablesUtils.excelInsertRow(sheet, 1, report_name);
        headerRows += 1;

        var totalDataRows = $('row:gt(' + headerRows + ')', sheet).length;

        let tableData = [];
        table_api.rows({ search: 'applied' }).every(function () {
          tableData.push(this.data());
        });

        $('row:gt(' + headerRows + ')', sheet).each(function (row_index, value) {
          let className = null;
          if (custom_styles && row_index != totalDataRows - 1) { 
            if (custom_styles.getClassName) {
              className = custom_styles.getClassName(tableData[row_index], null);
            }
          }

          for (var col_index = 0; col_index < visible_columns.length; col_index++) {

            if (row_index === totalDataRows - 1 && $('c', this).eq(col_index).attr('s') == '2') {
              return;
            }

            if (className) {
              $('c', this).eq(col_index).attr('s', custom_styles.ids[className]);
            } else {
              $('c', this).eq(col_index).attr('s', generalRightAlignedStyleId.toString());
              if (visible_columns[col_index].type === 'num') {
                $('c', this).eq(col_index).attr('s', generalRightAlignedStyleId.toString());
              } else if (visible_columns[col_index].type === 'date') {
                var currentCell = $('c', this).eq(col_index);
                var colDef = visible_columns[col_index];
                var rowData = tableData[row_index] || {};
                var rawValue = rowData ? rowData[colDef.data] : '';
                var dateValue = (rawValue == null) ? '' : String(rawValue);
                var hasTime = dateValue.indexOf(':') >= 0;

                if (dateValue) {
                  currentCell.removeAttr('t');
                  var m = hasTime ? moment.utc(dateValue) : moment.utc(dateValue, ['YYYY-MM-DD', moment.ISO_8601], true);
                  if (!m.isValid()) {
                    m = moment.utc(dateValue);
                  }
                  if (m.isValid()) {
                    var excelDateInt = (m.unix() / 86400) + 25569;
                    if (hasTime) {
                      currentCell[0].innerHTML = '<v>' + excelDateInt.toString() + '</v>';
                      currentCell.attr('s', dateTimeRightAlignedStyleId.toString());
                    } else {
                      currentCell[0].innerHTML = '<v>' + Math.trunc(excelDateInt).toString() + '</v>';
                      currentCell.attr('s', dateRightAlignedStyleId.toString());
                    }
                  } else {
                    currentCell[0].innerHTML = '<v></v>';
                  }
                } else {
                  currentCell[0].innerHTML = '<v></v>';
                }
              } else {
                $('c', this).eq(col_index).attr('s', generalLeftAlignedStyleId.toString());
              }
            }
          }
        });

        $('row:eq(' + headerRows + ')', sheet).each(function () {
          for (var col_index = 0; col_index < visible_columns.length; col_index++) {
            if (visible_columns[col_index].type === 'num' || visible_columns[col_index].type === 'date') {
              $('c', this).eq(col_index).attr('s', headerRightAlignedStyleId.toString());
            } else {
              $('c', this).eq(col_index).attr('s', headerLeftAlignedStyleId.toString());
            }
          }
        });

        var startCell = 'A' + (headerRows + 1).toString();

        var charsInAlphabet = 26;
        var firstChar = Math.floor(visible_columns.length / charsInAlphabet);
        var secondChar = visible_columns.length % charsInAlphabet;
        var asciiA = 'A'.charCodeAt();

        if (secondChar === 0 && firstChar > 0) {
          firstChar --;
          secondChar = charsInAlphabet;
        }

        var endChar = '';
        if (firstChar > 0) {
          endChar = String.fromCharCode(asciiA + firstChar - 1);
        }
        if (secondChar > 0) {
          endChar += String.fromCharCode(asciiA + secondChar - 1);
        }

        var endCell = endChar + (totalDataRows + headerRows + 1).toString();
        sheet.childNodes[0].children[2].attributes['ref'].value = startCell + ':' + endCell;
      }
    };

    return btn_excel;
  };

  function toggleColumnsVisibility(dt, visible) {
    try {
      dt.columns(':not(.skipCol)').visible(visible);
    } catch (err) {
      dt.columns().every(function () {
        const header = $(this.header());
        if (header && header.hasClass && !header.hasClass('skipCol')) {
          this.visible(visible);
        }
      });
    }
  }

  dataTablesUtils.setupColumnVisibilityListener = function (dt) {
    if (!dt._dataTablesUtils_hasColvisListener) {
      dt.on('column-visibility.dt', function (e, settings, column, state) {
        var hasVisibleColumns = false;
        dt.columns(':not(.skipCol)').every(function () {
          if (this.visible()) {
            hasVisibleColumns = true;
            return false; 
          }
        });

        var tableWrapper = $(dt.table().container()).closest('.dataTables_wrapper');

        if (!tableWrapper.data('original-overflow')) {
          tableWrapper.data('original-overflow', tableWrapper.css('overflow') || 'auto');
          tableWrapper.data('original-position', tableWrapper.css('position') || 'static');
        }

        if (hasVisibleColumns) {
          tableWrapper.css({
            'overflow': tableWrapper.data('original-overflow'),
            'position': tableWrapper.data('original-position')
          });
          dt.columns.adjust().draw();
        } else {
          tableWrapper.css({'overflow': 'visible', 'position': 'absolute'});
        }
      });
      dt._dataTablesUtils_hasColvisListener = true;
    }
  };

  dataTablesUtils.cleanupColumnVisibilityListener = function (dt) {
    if (dt._dataTablesUtils_hasColvisListener) {
      dt.off('column-visibility.dt');
      dt._dataTablesUtils_hasColvisListener = false;

      var tableWrapper = $(dt.table().container()).closest('.dataTables_wrapper');
      tableWrapper.removeData('original-overflow original-position');
    }
  };

  dataTablesUtils.get_visibility_button = function () {
    return {
      extend: 'collection',
      text: '<i class="fa fa-th me-2"></i>Toggle Columns',
      className: 'mat ui toggle-column-button small primary button',
      autoClose: true,
      init: function (dt, node, config) {
        dataTablesUtils.setupColumnVisibilityListener(dt);

        dt.on('destroy.dt', function() {
          dataTablesUtils.cleanupColumnVisibilityListener(dt);
        });

        $(node).find('.dt-button-down-arrow').remove();
        $(node).find('span.dt-down-arrow').remove();
      },
      buttons: [
        {
          text: '<i class="fa fa-check-square-o me-2"></i>Select All',
          className: 'mat ui small primary button',
          action: function (e, dt, node, config) {
            toggleColumnsVisibility(dt, true);
            var tableWrapper = $('.dataTables_wrapper');
            if (tableWrapper.data('original-overflow')) {
              tableWrapper.css({
                'overflow': tableWrapper.data('original-overflow'),
                'position': tableWrapper.data('original-position')
              });
            } else {
              tableWrapper.css({'overflow': '', 'position': ''});
            }
            dt.columns.adjust().draw();
          }
        },
        {
          text: '<i class="fa fa-square-o me-2"></i> Deselect All',
          className: 'mat ui small primary button',
          action: function (e, dt, node, config) {
            toggleColumnsVisibility(dt, false);
            var tableWrapper = $('.dataTables_wrapper');
            if (!tableWrapper.data('original-overflow')) {
              tableWrapper.data('original-overflow', tableWrapper.css('overflow') || 'auto');
              tableWrapper.data('original-position', tableWrapper.css('position') || 'static');
            }
            tableWrapper.css({'overflow': 'visible', 'position': 'absolute'});
          }
        },
        {
          extend: 'colvis',
          collectionLayout: 'two-column',
          text: '<i class="fa fa-columns me-2"></i>Select Columns',
          className: 'mat ui small primary button',
          columns: ':not(.skipCol)',
          columnText: function (dt, idx, title) {
            return title.length > 20 ? title.substring(0, 18) + '&hellip;' : title;
          },
          init: function (dt, node, config) {
            $(node).find('.dt-button-down-arrow').remove();
            $(node).find('span.dt-down-arrow').remove();
          }
        }
      ]
    };
  };

  dataTablesUtils.get_visibility_excel_buttons = function (report_name, user,
    scope, dropdown, show_visibility_button, custom_headers, report_table_key, report_columns_key, custom_styles) {

    report_table_key = (report_table_key == null || report_table_key == '')
      ? 'report_table'
      : report_table_key;

    report_columns_key = (report_columns_key == null || report_columns_key == '')
      ? 'report_columns'
      : report_columns_key;

    var btn_excel = dataTablesUtils.get_excel_button(report_name,
      user,
      scope,
      dropdown,
      custom_headers,
      report_table_key,
      report_columns_key,
      custom_styles
    );
    var btn_visibility = dataTablesUtils.get_visibility_button();

    return [btn_visibility, btn_excel];
  };


  dataTablesUtils.get_export_buttons = function (report_name, user, scope, dropdown,
    show_visibility_button, custom_headers, report_table_key, report_columns_key, custom_styles) {
    report_table_key = (report_table_key == null || report_table_key == '')
      ? 'report_table'
      : report_table_key;

    report_columns_key = (report_columns_key == null || report_columns_key == '')
      ? 'report_columns'
      : report_columns_key;

    if (!angular.isDefined(scope[report_columns_key])) {
      alert(
        'report_columns is not defined. Please check the provided report_columns_key if applicable.');
      return;
    }

    var btn_pdf = dataTablesUtils.get_pdf_button(report_name,
      user,
      scope,
      dropdown,
      custom_headers,
      report_table_key,
      report_columns_key);
    var btn_excel = dataTablesUtils.get_excel_button(report_name,
      user,
      scope,
      dropdown,
      custom_headers,
      report_table_key,
      report_columns_key,
      custom_styles);
    var btn_csv = dataTablesUtils.get_csv_button(report_name,
      user,
      scope,
      dropdown,
      custom_headers,
      report_table_key,
      report_columns_key);
    var btn_visibility = dataTablesUtils.get_visibility_button();

    var result = [btn_pdf, btn_excel, btn_csv];
    if (!dropdown && show_visibility_button) {
      result.unshift(btn_visibility);
    }

    return result;
  };

  this.getRowByElement = function (table_id, elt) {
    var table = $('#' + table_id).DataTable();
    return table.row($(elt).parent().parent()).data();
  };

  this.getTdByMeta = function (meta) {
    if (!meta) return;
    var api = new $.fn.dataTable.Api(meta.settings);
    return $(api.cell(meta.row, meta.col).node());
  };

  this.createRenderActiveFunction = function (toggleFnName) {
    return function (name, type, row) {
      if (type === 'filter') {
        if (name == true) {
          return ACTIVE;
        } else {
          return INACTIVE;
        }
      }

      if (name == true) {
        return '<input type="button" value="Deactivate" onclick="javascript:' + toggleFnName +
            '(this, ' + row.id + ', true)" id="ctl00_MainContent_grd_ctl00_ctl06_5" ' +
            'class="mat ui critical button" >';
      } else {
        return '<input type="button" value="Activate" onclick="javascript:' + toggleFnName +
            '(this, ' + row.id + ', false)" id="ctl00_MainContent_grd_ctl00_ctl04_ReActivate_9" ' +
            'class="mat ui primary button" /> ';
      }
    };
  };

  dataTablesUtils.get_green_icon = function (title) {
    return '<i title=\'' + title + '\' class=\'green fa fa-fw fa-check-circle\'></i>';
  };

  dataTablesUtils.get_yellow_icon = function (title) {
    return '<i title=\'' + title + '\' class=\'amber fa fa-fw fa-exclamation-circle\'></i>';
  };

  dataTablesUtils.get_red_icon = function (title) {
    return '<i title=\'' + title + '\' class=\'red fa fa-fw fa-exclamation-circle\'></i>';
  };

  dataTablesUtils.get_grey_icon = function (title) {
    return '<i title=\'' + title + '\' class=\' fa fa-fw fa-circle\'></i>';
  };

  dataTablesUtils.renderStatusSubmittedPayerResponse = function () {
    var states = [
      { 'data': -1, 'title': 'Expired Assignment', 'class': 'red fa fa-fw fa-calendar' },
      { 'data': 2, 'title': 'Pending Approval', 'class': 'red fa fa-fw fa-exclamation-circle' },
      {
        'data': 1,
        'title': 'Pending Response from Payer',
        'class': 'amber fa fa-fw fa-exclamation-circle'
      },
      { 'data': 0, 'title': 'Response Approved', 'class': 'green fa fa-fw fa-check-circle' }
    ];

    var getIcon = function (data, row) {
      if (row.expired) {
        return '<i title=\'' + states[0].title + '\' class=\'' + states[0].class + '\'></i>';
      }

      for (var i = 0; i < states.length; i++) {
        if (data == states[i].data) {
          return '<i title=\'' + states[i].title + '\' class=\'' + states[i].class + '\'></i>';
        }
      }
    };

    return function (data, type, row) {
      return '<div style="width:65px; text-align:center;">' + getIcon(data, row) +
          '<span style="display:none;">' + data + '</span>' + 
          '</div>';
    };
  };

  dataTablesUtils.get_render_btn_action2 = function (wrapper_fn_name, scope_fn_name, btn_text, btn_class) {
    return function (data, type, row) {
      return '<a onclick="javascript:' + wrapper_fn_name + '(this, \'' + scope_fn_name + '\', ' + data + ')" class="' + btn_class + '" >' + btn_text + '</a>';
    };
  };

  dataTablesUtils.get_render_checkbox = function (wrapper_fn_name, scope_fn_name) {
    return function (data, type, row) {
      return '<input type="checkbox" onchange="' + wrapper_fn_name + '(this, \'' + scope_fn_name + '\', ' + data + ')" />';
    };
  };

  dataTablesUtils.render = function (toggleFnName, btnTextTrue, btnTextFalse) {
    return function (data, type, row) {
      if (type === 'filter') {
        if (data == true) {
          return ACTIVE;
        } else {
          return INACTIVE;
        }
      }

      if (data == true) {
        return '<input type="button" value="' + btnTextTrue + '" onclick="javascript:' +
            toggleFnName + '(this, ' + row.id + ', true)" id="ctl00_MainContent_grd_ctl00_ctl06_5" ' +
            'class="mat ui critical button" >';
      } else {
        return '<input type="button" value="' + btnTextFalse + '" onclick="javascript:' +
            toggleFnName + '(this, ' + row.id + ', false)" ' +
            'id="ctl00_MainContent_grd_ctl00_ctl04_ReActivate_9" class="mat ui primary button" /> ';
      }
    };
  };
}]
);
